// extracted by mini-css-extract-plugin
export default {"services":"Services_services__9HEKD","service-cards":"Services_service-cards__Gpo9R"};